import { render } from "./XIconSolidHandShake.vue?vue&type=template&id=2e21c54e"
import script from "./XIconSolidHandShake.vue?vue&type=script&lang=js"
export * from "./XIconSolidHandShake.vue?vue&type=script&lang=js"

import exportComponent from "/Users/hamid/Nova/onsho24/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"XIconSolidHandShake.vue"]])

export default __exports__